<script>
    import { getCSSVar } from '$lib/utils'
    export let disabled = false
    export let icon = null
    export let size = 64
    export let title = ''
    export let color = getCSSVar('--color-brand-primary-01')
    import { createEventDispatcher } from 'svelte'
    import { AddOutline } from '../Icons'
    const dispatch = createEventDispatcher()
    function mousedown() {
        dispatch('mousedown', {})
    }
    function mouseup() {
        dispatch('mouseup', {})
    }
    function mouseover() {
        dispatch('mouseover', {})
    }
    function mouseout() {
        dispatch('mouseout', {})
    }
    function dblclick() {
        dispatch('dblclick', {})
    }
    function click() {
        dispatch('click', {})
    }
    function contextmenu() {
        dispatch('contextmenu', {})
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1) click()
    }
    $: color = color.match(/#|rgb/) ? color : getCSSVar(color)
    $: style = `width: ${typeof size == 'string' ? size : size + 'px'}; height: ${
        typeof size == 'string' ? size : size + 'px'
    }`
</script>

<div
    {style}
    {title}
    tabindex="0"
    class={disabled ? 'disabled' : ''}
    on:keypress={keypress}
    on:click={disabled ? (_) => {} : click}
    on:dblclick={disabled ? (_) => {} : dblclick}
    on:mousedown={disabled ? (_) => {} : mousedown}
    on:mouseup={disabled ? (_) => {} : mouseup}
    on:mouseover={disabled ? (_) => {} : mouseover}
    on:mouseout={disabled ? (_) => {} : mouseout}
    on:contextmenu={disabled ? (_) => {} : contextmenu}
    on:focus={(_) => {}}
    on:blur={(_) => {}}
>
    {#if icon}
        <svelte:component this={icon} size={size / 2} {color} />
    {:else}
        <AddOutline size={size / 2} {color} />
    {/if}
</div>

<style>
    div {
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
        cursor: pointer;
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
        transition: all 0.15s ease-in-out;
    }
    div:hover {
        background: rgba(255, 255, 255, 0.85);
    }
    div:active {
        transform: scale(0.99);
        background: rgba(255, 255, 255, 0.9);
    }
    .disabled {
        opacity: 0.3;
        cursor: no-drop;
    }
</style>
